import { render, staticRenderFns } from "./faqPage.vue?vue&type=template&id=10f732cb&"
import script from "./faqPage.vue.ts?vue&type=script&lang=ts&"
export * from "./faqPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports